/** @format */

import { createSlice } from '@reduxjs/toolkit';
// import _ from 'lodash';
import axios from 'src/utils/axios';
import { ENDPOINTS } from 'src/constants';

const initialState = {
  ticketLoading: false,
  updateTicketLoading: false,
  addressesLoading: false,
  ticketDetail: null,
  tickets: null,
  companyTickets: null,
  searchTickets: null,
  addresses: null,
  error: null
};

const slice = createSlice({
  name: 'tickets',
  initialState,
  reducers: {
    //Get tickets
    getTickets(state) {
      state.ticketLoading = true;
    },
    getTicketsSuccess(state, action) {
      const data = action.payload;
      state.tickets = data.value || [];
      state.ticketLoading = false;
    },
    getTicketsFailure(state, action) {
      state.error = action.payload;
      state.ticketLoading = false;
    },
    getCompanyTicketsSuccess(state, action) {
      const data = action.payload;
      state.companyTickets = data.value || [];
      state.ticketLoading = false;
    },
    getSearchTicketsSuccess(state, action) {
      const data = action.payload;
      state.searchTickets = data.value || [];
      state.ticketLoading = false;
    },
    getTicketDetail(state, action) {
      state.ticketLoading = true;
    },
    getTicketDetailSuccess(state, action) {
      const data = action.payload;
      state.ticketDetail = data || {};
      state.ticketLoading = false;
    },
    resetTicketDetailLoading(state, action) {
      state.ticketLoading = true;
    },
    getTicketDetailFailure(state, action) {
      state.error = action.payload;
      state.ticketLoading = false;
    },
    createTicket(state, action) {
      state.updateTicketLoading = true;
    },
    createTicketSuccess(state, action) {
      state.updateTicketLoading = false;
    },
    createTicketFailure(state, action) {
      state.error = action.payload;
      state.updateTicketLoading = false;
    },
    updateTicket(state, action) {
      state.updateTicketLoading = true;
    },
    updateTicketSuccess(state, action) {
      state.updateTicketLoading = false;
    },
    updateTicketFailure(state, action) {
      state.error = action.payload;
      state.updateTicketLoading = false;
    },
    clearTicketError(state, action) {
      state.error = null;
    },
    getAddresses(state, action) {
      state.addressesLoading = true;
    },
    getAddressesSuccess(state, action) {
      const data = action.payload;
      state.addresses = data.data || {};
      state.addressesLoading = false;
    },
    getAddressesFailure(state, action) {
      state.error = action.payload;
      state.addressesLoading = false;
    }
  }
});

export const reducer = slice.reducer;

// Tickets
export const getTickets = () => async dispatch => {
  const { getTickets, getTicketsSuccess, getTicketsFailure } = slice.actions;
  try {
    dispatch(getTickets());
    const response = await axios.get(`${ENDPOINTS.GET_TICKETS_ENDPOINT}/?limit=100`);
    dispatch(getTicketsSuccess(response.data));
  } catch (err) {
    dispatch(getTicketsFailure(err));
  }
};
export const getCompanyTickets = () => async dispatch => {
  const { getTickets, getCompanyTicketsSuccess, getTicketsFailure } = slice.actions;
  try {
    dispatch(getTickets());
    const response = await axios.get(`${ENDPOINTS.GET_TICKETS_COMPANY_ENDPOINT}/?limit=100`);
    dispatch(getCompanyTicketsSuccess(response.data));
  } catch (err) {
    dispatch(getTicketsFailure(err));
  }
};
export const getSearchTickets =
  ({ query }) =>
  async dispatch => {
    const { getTickets, getSearchTicketsSuccess, getTicketsFailure } = slice.actions;
    try {
      dispatch(getTickets());
      const response = await axios.get(`${ENDPOINTS.GET_TICKETS_COMPANY_ENDPOINT}/search/?query=${query}`);
      dispatch(getSearchTicketsSuccess(response.data));
    } catch (err) {
      dispatch(getTicketsFailure(err));
    }
  };

export const getTicketDetail = id => async dispatch => {
  const { getTicketDetail, getTicketDetailSuccess, getTicketDetailFailure } = slice.actions;
  try {
    dispatch(getTicketDetail());
    const response = await axios.get(`${ENDPOINTS.GET_TICKETS_ENDPOINT}/${id}`);
    dispatch(getTicketDetailSuccess(response.data));
  } catch (err) {
    dispatch(getTicketDetailFailure(err));
  }
};

export const getCompanyTicketDetail = id => async dispatch => {
  const { getTicketDetail, getTicketDetailSuccess, getTicketDetailFailure } = slice.actions;
  try {
    dispatch(getTicketDetail());
    const response = await axios.get(`${ENDPOINTS.GET_TICKETS_COMPANY_ENDPOINT}/${id}`);
    dispatch(getTicketDetailSuccess(response.data));
  } catch (err) {
    dispatch(getTicketDetailFailure(err));
  }
};

export const createTicket = postData => async dispatch => {
  const { createTicket, createTicketSuccess, createTicketFailure } = slice.actions;
  try {
    dispatch(createTicket());
    const response = await axios.post(ENDPOINTS.GET_TICKETS_ENDPOINT, postData);
    if (!response.error) dispatch(createTicketSuccess(response.data));
  } catch (err) {
    dispatch(createTicketFailure(err));
  }
};
export const createTicketFormData = formData => async dispatch => {
  const { createTicket, createTicketSuccess, createTicketFailure } = slice.actions;
  try {
    dispatch(createTicket());
    const response = await axios({
      method: 'post',
      url: ENDPOINTS.GET_TICKETS_ENDPOINT,
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    if (!response.error) dispatch(createTicketSuccess(response.data));
  } catch (err) {
    dispatch(createTicketFailure(err));
  }
};

export const updateTicket = postData => async dispatch => {
  const { updateTicket, updateTicketSuccess, updateTicketFailure } = slice.actions;
  try {
    dispatch(updateTicket());
    const response = await axios.patch(`${ENDPOINTS.GET_TICKETS_ENDPOINT}/${postData.incidentid}`, postData);
    if (!response.error) dispatch(updateTicketSuccess(response.data));
  } catch (err) {
    dispatch(updateTicketFailure(err));
  }
};

export const clearTicketError = () => dispatch => {
  const { clearTicketError } = slice.actions;
  dispatch(clearTicketError());
};

export const getAddresses = () => async dispatch => {
  const { getAddresses, getAddressesSuccess, getAddressesFailure } = slice.actions;
  try {
    dispatch(getAddresses());
    const response = await axios.get(ENDPOINTS.GET_TICKETS_ADDRESSES_ENDPOINT);
    dispatch(getAddressesSuccess(response.data));
  } catch (err) {
    dispatch(getAddressesFailure(err));
  }
};

export const resetTicketDetailLoading = () => dispatch => {
  const { resetTicketDetailLoading } = slice.actions;
  dispatch(resetTicketDetailLoading());
};

export default slice;
